import { Base } from '@studiometa/js-toolkit';
import ParallaxHero from '../atoms/ParallaxHero.js';

/**
 * HeroHome component
 */
export default class HeroHome extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroHome',
    components: {
      ParallaxHero,
    },
  };

  /**
   * @param {HTMLElement} el the entering item
   */
  onParallaxHeroItemEnter(el) {
    if (el && this.$children.ParallaxHero) {
      this.$children.ParallaxHero.forEach((element) => {
        if (element.$el !== el) {
          element.$refs.grayscale.classList.add('grayscale');
        }
      });
    }
  }

  /**
   *
   */
  onParallaxHeroItemLeave() {
    this.$children.ParallaxHero.forEach((element) => {
      if (element && element.$refs.grayscale) {
        element.$refs.grayscale.classList.remove('grayscale');
      }
    });
  }
}
